var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "title" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "/" } },
            [
              _c("el-breadcrumb-item", [_vm._v("业务管理")]),
              _c("el-breadcrumb-item", [_vm._v("人员管理")]),
              _c("el-breadcrumb-item", [_vm._v("资源管理")])
            ],
            1
          )
        ],
        1
      ),
      _c("div", { staticClass: "title-en" }, [_vm._v("鸿云Dcops在库人员")]),
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c("fontal-dcops-staff-table", {
            attrs: { "header-style": _vm.headerStyle },
            on: {
              edit: _vm.handleEdit,
              delete: _vm.handleDelete,
              history: _vm.handleHistory
            }
          })
        ],
        1
      ),
      _c("div", { staticClass: "title-en" }, [
        _vm._v("1.合作资源人员（外部）")
      ]),
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c("staff-resource-table", {
            attrs: { "header-style": _vm.headerStyle },
            on: {
              edit: _vm.handleEdit,
              delete: _vm.handleDelete,
              history: _vm.handleHistory
            }
          })
        ],
        1
      ),
      _c("div", { staticClass: "title-en" }, [
        _vm._v("2.专职专项人员（员工）")
      ]),
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c("staff-special-table", {
            attrs: { "header-style": _vm.headerStyle },
            on: {
              edit: _vm.handleEdit,
              delete: _vm.handleDelete,
              history: _vm.handleHistory
            }
          })
        ],
        1
      ),
      _c("div", { staticClass: "title-en" }, [_vm._v("3.计费HC人员（员工）")]),
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c("staff-hc-table", {
            attrs: { "header-style": _vm.headerStyle },
            on: {
              edit: _vm.handleEdit,
              delete: _vm.handleDelete,
              history: _vm.handleHistory
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }